import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { Form } from 'reactstrap'
import _uniqBy from 'lodash.uniqby'

import { getFilters, updateFilters, updateAdvancedFilters } from 'redux/actions/marketing'
import AdvancedFilters from './AdvancedFilters'
import BasicFilters from './BasicFilters'

const Filters = ({ getUsers, advanced = false, setNoUsersText, removePreview, getUsersAdvancedFilters, campaign }) => {
  const dispatch = useDispatch()
  const [filters, setFilters] = useState({})
  const [filtersFetched, setFiltersFetched] = useState(false)
  const { advancedFilters, filterTickets: previousBasicFilters } = campaign

  useEffect(() => {
    // get all filters
    dispatch(getFilters())
      .then((data) => {
        setFilters(data)
        setFiltersFetched(true)
      })
      .catch((error) => console.error(error))
    return () => {
      setFilters({})
      setFiltersFetched(false)
    }
  }, [dispatch])

  /* Set basic filters in redux */
  const setBasicFilters = ({ label = null, data = null }) => {
    removePreview()
    if (data) {
      // dispatch(updateFilters({ [label]: data[0] && data[0].value === 'all' ? filters[label] : data }))
      dispatch(updateFilters({ [label]: data }))
    } else {
      dispatch(updateFilters({ [label]: [] }))
    }
  }

  /** Set advanced filters in redux */
  const setAdvancedFilters = (data) => {
    // get campaign.advancedFilters
    const { filters = [] } = advancedFilters
    // remove duplicate filters
    data.filters = _uniqBy(filters.concat(data.filters), (v) => [v.type, v.option, v.value].join())
    dispatch(updateAdvancedFilters(data))
  }

  return (
    <>
      <Form style={{ paddingLeft: 10 }} className={'animated fadeIn'}>
        {!advanced && filtersFetched && (
          <BasicFilters
            filters={filters}
            getUsers={getUsers}
            setBasicFilters={setBasicFilters}
            removePreview={removePreview}
            previousBasicFilters={previousBasicFilters}
          />
        )}
        {advanced && filtersFetched && (
          <AdvancedFilters
            filters={filters}
            setNoUsersText={setNoUsersText}
            removePreview={removePreview}
            updateReduxAdvancedFilters={setAdvancedFilters}
            getUsersAdvancedFilters={getUsersAdvancedFilters}
            campaign={campaign}
            advancedFilters={advancedFilters}
          />
        )}
      </Form>
    </>
  )
}

export default Filters
